// @file Surface ai chat store tool calls
import { trackEvent } from '@@/bits/analytics'
import { captureException } from '@@/bits/error_tracker'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useSurfaceTranslationsStore } from './surface_translations_store'

enum Tool {
  TranslatePadlet = 'translate_padlet',
}

type ToolParams = {
  [Tool.TranslatePadlet]: { targetLanguage: string }
}

export const useSurfaceAIChatToolsStore = defineStore('surfaceAIChatToolsStore', () => {
  const surfaceTranslationsStore = useSurfaceTranslationsStore()

  const isRunningTool = ref<boolean>(false)

  const translatePadlet = async (args: ToolParams[Tool.TranslatePadlet]): Promise<void> => {
    if (args == null || args.targetLanguage == null || args.targetLanguage?.length < 1) {
      throw new Error(`SurfaceAiChatToolsStore: Invalid params for translation tool`)
    }

    await surfaceTranslationsStore.translatePadletFromSurfaceAiChat(args.targetLanguage)
  }

  const TOOL_HANDLERS = {
    [Tool.TranslatePadlet]: translatePadlet,
  }

  const executeTool = async (params: any): Promise<void> => {
    try {
      isRunningTool.value = true
      const toolHandler = TOOL_HANDLERS[params.name]
      if (toolHandler == null) throw new Error(`SurfaceAiChatToolsStore: Unknown tool call: ${params.name}`)

      await toolHandler(params.args)

      trackEvent('Surface AI chat', 'Executed tool', null, null, params)
    } catch (e) {
      captureException(e)
    } finally {
      isRunningTool.value = false
    }
  }

  return {
    isRunningTool,
    executeTool,
  }
})
